import { Icon, TextButton } from '@joor/design-system'

import { EmptyPayOrdersOverlayTestIds } from '../EmptyPayOrdersOverlay'
import { Body, Container, Header } from './Common.ui'

export function JoorPayEnabledOverlay({ onLinkClick }: Props) {
  return (
    <Container>
      <Icon
        data-testid={EmptyPayOrdersOverlayTestIds.OverlayIconOrder}
        iconName="order"
        iconSize="extraLarge"
        plain
      />
      <Header>{CONTENT.HEADER_TEXT}</Header>
      <Body>
        {CONTENT.BODY_TEXT_1}{' '}
        {<TextButton onClick={onLinkClick}>{CONTENT.LINK_TEXT}</TextButton>}{' '}
        {CONTENT.BODY_TEXT_2}
      </Body>
    </Container>
  )
}

type Props = {
  onLinkClick: () => void
}

export const CONTENT = {
  HEADER_TEXT: 'No JOOR Pay Orders',
  BODY_TEXT_1:
    'You have not created any JOOR Pay orders. Send a payment request from the',
  LINK_TEXT: 'All Orders',
  BODY_TEXT_2:
    'tab or from inside order review to add orders to this list.' +
    " Any order you receive a payment on, even if you haven't sent the request yet, will also appear here.",
}
